import { IS_STAGE } from '~/core/constants';
export default defineComponent({
  name: 'EnvironmentBanner',
  setup: function setup() {
    return {
      IS_STAGE: IS_STAGE
    };
  }
});